import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import {Form} from 'react-final-form'
import {FormattedMessage, useIntl} from "react-intl";

import TextBoxField from "../../../components/common/TextBox/TextBoxField";
import {GOOGLE_CAPTCHA_API_KEY} from "../../../constants/Registration";
import Button from "../../../components/common/Button/Button";
import {AuthorizationLink} from "../../../components/registration/AuthorizationLink/AuthorizationLink";
import {getRootUrl} from '../../../helpers/UrlHelper';

export const RememberPasswordForm = ({onSubmit, lang}) => {
    const intl = useIntl();
    const [captcha, setCaptchaValue] = useState(null);

    const onFormSubmit = (formValue) => {
        return onSubmit({...formValue, captcha});
    };

    const goMainPage = useCallback(() => window.location.replace(getRootUrl()), []);

    return (
        <React.Fragment>
            <AuthorizationLink
                text="remPass.reg_has_acc"
                link="remPass.reg_auth"
            />

            <Form onSubmit={onFormSubmit}>
                {
                    ({handleSubmit}) => {
                        return (
                            <form
                                autoComplete="off"
                                noValidate
                                onSubmit={handleSubmit}
                                className="mt-2">
                                <TextBoxField
                                    inline
                                    labelClass="col-4"
                                    inputClass="col-8"
                                    name="email"
                                    label={intl.formatMessage({id: "remPass.email"})}/>
                                <div className="Health-form__field row">
                                    <label className="col-4"/>
                                    <div className="col-8">
                                        <ReCAPTCHA
                                            sitekey={GOOGLE_CAPTCHA_API_KEY}
                                            onChange={setCaptchaValue}
                                            hl={lang}
                                        />
                                    </div>
                                </div>
                                <div className="Flex-row Justify-space-between mt-2 mb-4">
                                    <Button
                                        viewType="minimal"
                                        variant="gray"
                                        onClick={goMainPage}>
                                        <FormattedMessage id="remPass.but_back_main"/>
                                    </Button>
                                    <Button type={'submit'}>
                                        <FormattedMessage id="remPass.but_send"/>
                                    </Button>
                                </div>
                            </form>
                        )
                    }
                }
            </Form>
        </React.Fragment>
    );
};

RememberPasswordForm.propTypes = {
    redirectTo: PropTypes.string,
};


export default RememberPasswordForm;
